import React from "react";
import cn from "classnames";
import s from "./Legend.module.scss";

interface IOwnProps {
  legendItems: ILegendItem[];
  totalItem?: ILegendItem;
  showTotal?: boolean;
}

interface ILegendItem {
  label: string;
  value?: string;
  color?: string;
}

export const Legend = ({
  legendItems: legendItemsIn,
  totalItem,
}: IOwnProps) => {
  const legendItems = [...legendItemsIn];
  if (totalItem) {
    legendItems.unshift(totalItem);
  }

  return (
    <div className={cn(s.surround, "legend-wrapper")}>
      {legendItems?.map((item) => (
        <div key={item.label} className={cn(s.itemSurround)}>
          {!!item.color && (
            <div
              className={cn(s.indicator, "legend-item")}
              style={{ backgroundColor: item.color ?? "blue" }}
            />
          )}
          {item.label}
          <br />
          {!!item.value && item.value}
        </div>
      ))}
    </div>
  );
};
